<template>
	<v-card class="app-favorite-link-form py-4 px-6">
		<ao-text-field
			v-model="form.title.model"
			clearable
			persistent-clear
			variant="underlined"
			type="text"
			color="primary"
			clear-icon="mdi-close"
			:label="$t('Link name')"
			:loading="form.title.$loading"
			:disabled="form.title.$loading"
			:error="!form.title.$valid && form.title.$touched"
			:error-messages="[
				...(form.title.$errors?.required && form.title.$touched
					? [$t('This field is required')]
					: []),
				...(form.title.$errors?.maxLength && form.title.$touched
					? ['Length must me less than 256']
					: []),
			]"
			@blur="form.title.onFieldBlur"
		/>
		<ao-text-field
			v-model="form.subtitle.model"
			clearable
			persistent-clear
			variant="underlined"
			type="text"
			color="primary"
			class="mt-n2"
			clear-icon="mdi-close"
			:label="$t('Description')"
			:loading="form.subtitle.$loading"
			:disabled="form.subtitle.$loading"
			:error="!form.subtitle.$valid && form.subtitle.$touched"
			:error-messages="[
				...(form.subtitle.$errors?.required && form.subtitle.$touched
					? [$t('This field is required')]
					: []),
				...(form.subtitle.$errors?.maxLength && form.subtitle.$touched
					? ['Length must me less than 256']
					: []),
			]"
			@blur="form.title.onFieldBlur"
		/>

		<div
			v-if="!hideGroupSelect"
			class="group-select"
		>
			<v-chip
				v-if="selectedGroup"
				variant="flat"
				color="secondary"
				closable
				class="ao-p2-regular"
				@click:close="selectedGroup = null"
			>
				<ao-icon
					class="mr-1"
					iconName="folder"
				/>
				<span style="color: #22282B;">{{ selectedGroup.name }}</span>
			</v-chip>
			<v-menu
				v-else
				:close-on-content-click="true"
			>
				<template v-slot:activator="{ props }">
					<ao-btn
						v-bind="props"
						prependIconName="plus"
						variant="plain"
						color="primary"
						class="ao-p2-regular pa-0 mt-3"
					>
						{{ $t('Add to group') }}
					</ao-btn>
				</template>
				<v-list>
					<ao-btn
						v-for="group in groups"
						:key="group.key"
						custom="favoriteSettingMenuItem"
						@click="selectedGroup = group"
					>
						{{ group.name }}
					</ao-btn>
				</v-list>
			</v-menu>
		</div>

		<div class="mt-4 d-flex">
			<ao-btn
				color="primary"
				variant="flat"
				:loading="loading"
				class="mr-3 px-3"
				@click="onSaveLink"
			>
				{{ $t('Save') }}
			</ao-btn>
			<ao-btn
				variant="text"
				class="px-3"
				@click="$emit('cancel')"
			>
				{{ $t('Cancel') }}
			</ao-btn>
		</div>
	</v-card>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

import FormManager from '@/services/formManager/formManagerService'
import { required, maxLength } from '@/services/formManager/formValidators'

const props = defineProps({
	currentState: {
		type: Object,
	},

	currentGroupKey: {
		type: String,
	},

	loading: {
		type: Boolean,
		default: false,
	},

	groups: {
		type: Array,
		default: () => [],
	},

	hideGroupSelect: {
		type: Boolean,
		default: false,
	},

	currentRoute: {
		type: Object,
		default: null,
	},
})

const emit = defineEmits({
	saveLink: null,
	cancel: null,
})

const { t: $t } = useI18n()

const form = FormManager({
	fields: {
		title: {
			validators: {
				required: (value) => required(value),
				maxLength: (value) => maxLength(value, 256),
			},
			defaultValue: () => props.currentState?.title || '',
		},
		subtitle: {
			validators: {
				required: (value) => required(value),
				maxLength: (value) => maxLength(value, 256),
			},
			defaultValue: () => props.currentState?.subtitle || '',
		},
	},
})

const selectedGroup = ref(null)

const onSaveLink = () => {
	if (form.validateForm()) {
		emit('saveLink', {
			title: form.title.model,
			subtitle: form.subtitle.model,
			groupKey: selectedGroup.value?.key ?? null,
		})
	}
}

onMounted(() => {
	// console.log('props.currentRoute', props.currentRoute)
	if (props.currentRoute?.meta?.titleTranslationKey) {
		/*
			не знаю по какой причине, но без таймаута не работает
			возможно еще не успевает отработать FormManager
			а возможно defaultValue выполняется позже чем создается инстанс FormManager-а
		*/
		setTimeout(() => {
			form.title.setFieldValue($t(props.currentRoute.meta.titleTranslationKey))
		}, 100)
	}
	if (props.currentGroupKey) {
		selectedGroup.value = props.groups.find((group) => group.key === props.currentGroupKey)
	}
})

</script>
